// src/App.js
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./pages/auth/Login";
import ChangePassword from "./pages/auth/ChangePassword";
import Settings from "./pages/compony/Settings";
import DashboardLayout from "./layouts/DashboardLayout";
import AuthGuard from "./components/AuthGuard";
import GuestGuard from "./components/GuestGuard";
import RequirePermission, {
  OwnerOnly,
  DashboardHome,
} from "./components/RequirePermission";

import Products from "./pages/products";
import EditProduct from "./pages/products/Edit";

import Customers from "./pages/customers";
import EditCustomer from "./pages/customers/Edit";

import Factors from "./pages/factors";
import NewFactor from "./pages/factors/New";
import EditFactor from "./pages/factors/Edit";
import PrintFactor from "./pages/factors/Print";
import Print2 from "./pages/factors/Print_2";

import Transactions from "./pages/transactions";
import NewTransaction from "./pages/transactions/New";
import EditTransaction from "./pages/transactions/Edit";

import Ledger from "./pages/ledger";
import LedgerPrint from "./pages/ledger/Print";

import Letters from "./pages/letters";
import NewLetter from "./pages/letters/New";
import EditLetter from "./pages/letters/Edit";
import LetterPrint from "./pages/letters/Print";

import Staff from "./pages/staff";
import StaffEdit from "./pages/staff/Edit";

import TitleManager from "./components/TitleManager";

import Logs from "./pages/logs";

function App() {
  return (
    <Router>
      <TitleManager />

      <Routes>
        {/* ============ ورود / تغییر رمز ============ */}
        <Route
          path="/login"
          element={
            <GuestGuard>
              <Login />
            </GuestGuard>
          }
        />

        <Route
          path="/change-password"
          element={
            <AuthGuard>
              <ChangePassword />
            </AuthGuard>
          }
        />

        {/* ============ صفحه‌های چاپ (خارج از Layout) ============ */}
        <Route
          path="/dashboard/factors/:id/print"
          element={
            <AuthGuard>
              <RequirePermission perm="factors.view">
                <PrintFactor />
              </RequirePermission>
            </AuthGuard>
          }
        />

        <Route
          path="/dashboard/factors/:id/print2"
          element={
            <AuthGuard>
              <RequirePermission perm="factors.view">
                <Print2 />
              </RequirePermission>
            </AuthGuard>
          }
        />

        <Route
          path="/dashboard/ledger/:customerId/print"
          element={
            <AuthGuard>
              <RequirePermission perm="ledger.view">
                <LedgerPrint />
              </RequirePermission>
            </AuthGuard>
          }
        />

        <Route
          path="/dashboard/letters/:id/print"
          element={
            <AuthGuard>
              <RequirePermission perm="letters.view">
                <LetterPrint />
              </RequirePermission>
            </AuthGuard>
          }
        />

        {/* ============ داشبورد و زیرمجموعه‌ها ============ */}
        <Route
          path="/dashboard"
          element={
            <AuthGuard>
              <DashboardLayout />
            </AuthGuard>
          }
        >
          <Route index element={<DashboardHome />} />

          <Route
            path="settings"
            element={
              <RequirePermission perm="settings.view">
                <Settings />
              </RequirePermission>
            }
          />

          {/* محصولات */}
          <Route
            path="products"
            element={
              <RequirePermission perm="products.view">
                <Products />
              </RequirePermission>
            }
          />
          <Route
            path="products/:id/edit"
            element={
              <RequirePermission perm="products.edit">
                <EditProduct />
              </RequirePermission>
            }
          />

          {/* مشتریان */}
          <Route
            path="customers"
            element={
              <RequirePermission perm="customers.view">
                <Customers />
              </RequirePermission>
            }
          />
          <Route
            path="customers/:id/edit"
            element={
              <RequirePermission perm="customers.edit">
                <EditCustomer />
              </RequirePermission>
            }
          />

          {/* فاکتورها */}
          <Route
            path="factors"
            element={
              <RequirePermission perm="factors.view">
                <Factors />
              </RequirePermission>
            }
          />
          <Route
            path="factors/new"
            element={
              <RequirePermission perm="factors.create">
                <NewFactor />
              </RequirePermission>
            }
          />
          <Route
            path="factors/:id/edit"
            element={
              <RequirePermission perm="factors.edit">
                <EditFactor />
              </RequirePermission>
            }
          />

          {/* تراکنش‌ها */}
          <Route
            path="transactions"
            element={
              <RequirePermission perm="transactions.view">
                <Transactions />
              </RequirePermission>
            }
          />
          <Route
            path="transactions/new"
            element={
              <RequirePermission perm="transactions.create">
                <NewTransaction />
              </RequirePermission>
            }
          />
          <Route
            path="transactions/:id/edit"
            element={
              <RequirePermission perm="transactions.edit">
                <EditTransaction />
              </RequirePermission>
            }
          />

          {/* دفتر کل */}
          <Route
            path="ledger"
            element={
              <RequirePermission perm="ledger.view">
                <Ledger />
              </RequirePermission>
            }
          />

          {/* نامه‌ها */}
          <Route
            path="letters"
            element={
              <RequirePermission perm="letters.view">
                <Letters />
              </RequirePermission>
            }
          />
          <Route
            path="letters/new"
            element={
              <RequirePermission perm="letters.create">
                <NewLetter />
              </RequirePermission>
            }
          />
          <Route
            path="letters/:id/edit"
            element={
              <RequirePermission perm="letters.edit">
                <EditLetter />
              </RequirePermission>
            }
          />

          {/* پرسنل (فقط مالک) */}
          <Route
            path="staff"
            element={
              <OwnerOnly>
                <Staff />
              </OwnerOnly>
            }
          />
          <Route
            path="staff/:id/edit"
            element={
              <OwnerOnly>
                <StaffEdit />
              </OwnerOnly>
            }
          />

          <Route
            path="logs"
            element={
              <OwnerOnly>
                <Logs />
              </OwnerOnly>
            }
          />
        </Route>

        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
